import Mithril from 'mithril';
import icon from 'flarum/common/helpers/icon';

const icons: Record<string, Mithril.Children> = {
  eur: icon('fas fa-euro-sign'),
  usd: icon('fas fa-dollar-sign'),
  yen: icon('fas fa-yen-sign'),
  gbp: icon('fas fa-pound-sign'),
  inr: icon('fas fa-rupee-sign'),
  aud: icon('fas fa-dollar-sign'),
  cad: icon('fas fa-dollar-sign'),
  cny: icon('fas fa-yen-sign'),
  nzd: icon('fas fa-dollar-sign'),
  rub: icon('fas fa-ruble-sign'),
  sgd: icon('fas fa-dollar-sign'),
  zar: icon('fas fa-dollar-sign'),
};

export default function currencySymbol(code: string) {
  return code
    ? icons[code] ??
        new Intl.NumberFormat('en-EN', {
          style: 'currency',
          currency: code,
        })
          .format(0)
          .replace('0.00', '')
    : '';
}
